import api from './api';
import { Cluster, CreateClusterRequest, PaginatedClusterResponse } from '../types';
import { API_ENDPOINTS } from '../constants';

const clusterService = {
  /**
   * Get paginated list of clusters
   */
  getClusters: async (params?: {
    page?: number;
    limit?: number;
    search?: string;
  }): Promise<PaginatedClusterResponse> => {
    const response = await api.get<{ success: boolean; message: string; data: PaginatedClusterResponse }>(API_ENDPOINTS.CLUSTERS.LIST, {
      params,
    });
    return response.data.data;
  },
  
  /**
   * Get cluster by ID
   */
  getClusterById: async (id: string): Promise<Cluster> => {
    const response = await api.get<{ success: boolean; message: string; data: Cluster }>(API_ENDPOINTS.CLUSTERS.GET_BY_ID(id));
    return response.data.data;
  },
  
  /**
   * Create new cluster
   */
  createCluster: async (clusterData: CreateClusterRequest): Promise<Cluster> => {
    const response = await api.post<{ success: boolean; message: string; data: Cluster }>(
      API_ENDPOINTS.CLUSTERS.CREATE,
      clusterData
    );
    return response.data.data;
  },
  
  /**
   * Update cluster
   */
  updateCluster: async (id: string, clusterData: Partial<CreateClusterRequest>): Promise<Cluster> => {
    const response = await api.put<{ success: boolean; message: string; data: Cluster }>(API_ENDPOINTS.CLUSTERS.UPDATE(id), clusterData);
    return response.data.data;
  },
  
  /**
   * DISABLED: Delete cluster - not permitted for anyone.
   * The backend cascades into hard-deleting every store in the cluster along
   * with their attendance and leave records. Irreversible.
   */
  // deleteCluster: async (id: string): Promise<void> => {
  //   await api.delete(API_ENDPOINTS.CLUSTERS.DELETE(id));
  // },
};

export default clusterService;
